import type { RequestInterceptor, ResponseInterceptor } from 'umi-request';
import qs from 'qs';

// 对 Request 的 url 和 options 做处理:
// 1. header: 兼容旧版本 api
export const requestInterceptors: RequestInterceptor[] = [
  (url, options) => {
    const headers = options.headers as Record<string, string>;
    const { data } = options;
    // 对 header 处理，主要目的是兼容旧接口
    // 旧接口处理逻辑：
    // 1. 默认采用 header['Content-Type'] = 'application/x-www-form-urlencoded'
    // 2. header['Content-Type'] = 'application/json'，需要在使用时指定
    // 3. header['Content-Type'] = 'multipart/form-data' 做了自动识别处理，不需要再指定
    let dataProcessed;
    const formData = new FormData();
    switch (headers['Content-Type']) {
      case 'multipart/form-data':
        if (data?.file) {
          formData.append('file', data.file);
          delete data.file;
        }
        formData.append('data', JSON.stringify(data));
        // FIX: formData上传不能设置headers['Content-Type']，umi-request会自动转换
        delete headers['Content-Type'];
        dataProcessed = formData;
        break;
      case 'application/json':
        dataProcessed = JSON.stringify(data);
        break;
      default:
        // 对应于 header['Content-Type'] === 'application/x-www-form-urlencoded'
        dataProcessed = qs.stringify(data);
    }
    return {
      url,
      options: {
        ...options,
        data: dataProcessed,
      },
    };
  },
];

// 对 Response 的 response 做处理
export const responseInterceptors: ResponseInterceptor[] = [
  (res) => {
    return res;
  },
];
